import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { PRIMARY_COURSE_ID } from '../course.constants';
import { normalizeCourseId } from '../course-id.aliases';
import { CourseContentService } from '../services/course-content.service';
import { LearnerStateService } from '../services/learner-state.service';

export const moduleAccessGuard: CanActivateFn = async (route): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const content = inject(CourseContentService);
  const state = inject(LearnerStateService);
  const courseId = normalizeCourseId(
    route.parent?.paramMap.get('courseId') ?? PRIMARY_COURSE_ID,
  );
  state.setCourseContext(courseId);

  const moduleId = route.paramMap.get('moduleId');

  // Beta-Test: Module sind ohne lokale Voucher-Prüfung direkt erreichbar.

  await content.load(courseId);

  const modules = content.modules();
  const module = modules.find((candidate) => candidate.id === moduleId);
  const firstModule = modules[0];
  if (!moduleId || !module) {
    return firstModule
      ? router.createUrlTree(['/kurse', courseId, 'module', firstModule.id])
      : router.createUrlTree(['/kurse', courseId, 'dashboard']);
  }

  const lessonId = route.paramMap.get('lessonId');
  if (lessonId && !module.lessons.some((lesson) => lesson.id === lessonId)) {
    return router.createUrlTree(['/kurse', courseId, 'module', module.id]);
  }

  return true;
};
